// VVI (Vorvertragliche Informationen)

import { Typography } from "@material-ui/core";
import VviBestaetigung from "./input/VviBestaetigung";

const FormVvi: React.FC = () => {
    return (
        <div>
            <div>
                <Typography variant='h4' color='textPrimary'>Fast geschafft! Nur noch zwei Schritte:</Typography>

                <div style={{ marginTop: 15 }} >
                    <VviBestaetigung />
                </div>
                <Typography variant='caption' color='textPrimary' display='block' style={{ marginTop: 10 }}>
                    Folgende Dokumente senden wir Ihnen vor Abschluss an Ihre E-Mail-Adresse zu: Verbraucherinformationen, Informationsblatt zu Versicherungsprodukten, AVB, Pauschaldeklaration, Datenschutzhinweise, Dienstleisterliste.
                </Typography>
            </div>
        </div >);
}

export default FormVvi;